import type { RootState } from "store";

export const selectGroups = (state: RootState) => state.packingList.groups;

export const selectGroupById = (id: string) => (state: RootState) => state.packingList.groups.find((g) => g.id === id);

export const selectCargoRowById = (groupId: string, rowId: string) => (state: RootState) =>
  state.packingList.groups.find((g) => g.id === groupId)?.cargoRows.find((r) => r.id === rowId);

export const selectGroupsCount = (state: RootState) => state.packingList.groups.length;

export const selectGroupIndex = (id: string) => (state: RootState) =>
  state.packingList.groups.findIndex((g) => g.id === id);

export const selectPalletRowByGroupId = (groupId: string) => (state: RootState) =>
  state.packingList.groups.find((g) => g.id === groupId)?.palletRow;

export const selectCustomPallets = (state: RootState) => state.packingList.customPallets;

export const selectShowCargoValidation = (state: RootState) => state.packingList.showCargoValidation;
